import { render, staticRenderFns } from "./MenuWrapperItem.vue?vue&type=template&id=327414a7&scoped=true"
import script from "./MenuWrapperItem.vue?vue&type=script&lang=js"
export * from "./MenuWrapperItem.vue?vue&type=script&lang=js"
import style0 from "./MenuWrapperItem.vue?vue&type=style&index=0&id=327414a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327414a7",
  null
  
)

export default component.exports